import { makeUseAxios } from 'axios-hooks';

import apiClient from '../utils/apiClient';

export default makeUseAxios({
  axios: apiClient,
});

export const headers = {
  'X-Mockable': 'false',
  'X-SourceSystem': 'CMS-SPA',
  'X-TrackingId': 'c07919b3-ef59-4502-b681-f0238db9049c',
  'X-Api-Context': 'CMS',
  'Content-Type': 'application/JSON',
};
